import { Impulse, useScoped } from "~/tools/impulse";

/**
 * This impulse holds whether drag-and-drop is enabled in the application.
 * It is initially false to avoid loading the heavy `beautiful-dnd` library
 * until the user actually tries to drag something.
 * As soon as the user hovers over a `DragHandle`, we set this to true,
 * which will cause all `DragAndDrop` components to load the library.
 */
const isDragAndDropEnabled = Impulse(false);

export function useIsEnabled(): boolean {
	return useScoped((scope) => isDragAndDropEnabled.getValue(scope));
}

export function enable(): void {
	isDragAndDropEnabled.setValue(true);
}
